"use client";

import { c as _c } from "react/compiler-runtime";
import { ModelSelector } from "@/components/model-selector";
import { McpServersDialog } from "@/components/playground/mcp-servers-dialog";
import { ShareChatDialog } from "@/components/playground/share-chat-dialog";
import { TempChatSwitcher } from "@/components/playground/temp-chat-switcher";
import { Label } from "@/components/ui/label";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Switch } from "@/components/ui/switch";
import { TooltipProvider } from "@/components/ui/tooltip";
import type { McpServer } from "@/hooks/useMcpServers";
import type { ApiModel, ApiProvider } from "@/lib/fetch-models";
import type { Organization } from "@/lib/types";
interface ChatHeaderProps {
  models: ApiModel[];
  providers: ApiProvider[];
  selectedModel: string;
  setSelectedModel: (model: string) => void;
  comparisonEnabled: boolean;
  onComparisonEnabledChange: (enabled: boolean) => void;
  hideCompare?: boolean;
  showGlobalModelSelector: boolean;
  // MCP servers props
  mcpServers: McpServer[];
  onAddMcpServer: (server: Omit<McpServer, "id">) => McpServer;
  onUpdateMcpServer: (id: string, updates: Partial<Omit<McpServer, "id">>) => void;
  onRemoveMcpServer: (id: string) => void;
  onToggleMcpServer: (id: string) => void;
  isTemporaryChat: boolean;
  onToggleTemporaryChat: () => void;
  showTemporaryChatSwitcher: boolean;
  isTemporaryChatToggleDisabled: boolean;
  hasTemporaryMessages: boolean;
  currentChatId: string | null;
  isShareChatDisabled?: boolean;
  shareId: string | null;
  orgShares: Array<{
    id: string;
    organizationId: string;
  }>;
  organizations: Organization[];
  chatTitle?: string | null;
  previewPrompt?: string | null;
}
export const ChatHeader = t0 => {
  const $ = _c(46);
  const {
    models,
    providers,
    selectedModel,
    setSelectedModel,
    comparisonEnabled,
    onComparisonEnabledChange,
    hideCompare: t1,
    showGlobalModelSelector,
    mcpServers,
    onAddMcpServer,
    onUpdateMcpServer,
    onRemoveMcpServer,
    onToggleMcpServer,
    isTemporaryChat,
    onToggleTemporaryChat,
    showTemporaryChatSwitcher,
    isTemporaryChatToggleDisabled,
    hasTemporaryMessages,
    currentChatId,
    isShareChatDisabled: t2,
    shareId,
    orgShares,
    organizations,
    chatTitle,
    previewPrompt
  } = t0;
  const hideCompare = t1 === undefined ? false : t1;
  const isShareChatDisabled = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== isTemporaryChat) {
    t3 = isTemporaryChat ? null : <SidebarTrigger />;
    $[0] = isTemporaryChat;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== models || $[3] !== providers || $[4] !== selectedModel || $[5] !== setSelectedModel || $[6] !== showGlobalModelSelector) {
    t4 = showGlobalModelSelector ? <div className="flex w-full min-w-0 max-w-[360px] items-center gap-2 sm:max-w-[420px]"><ModelSelector models={models} providers={providers} value={selectedModel} onValueChange={setSelectedModel} placeholder="Search and select a model..." /></div> : null;
    $[2] = models;
    $[3] = providers;
    $[4] = selectedModel;
    $[5] = setSelectedModel;
    $[6] = showGlobalModelSelector;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex min-w-0 flex-1 items-center gap-3">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== hasTemporaryMessages || $[12] !== isTemporaryChat || $[13] !== isTemporaryChatToggleDisabled || $[14] !== onToggleTemporaryChat || $[15] !== showTemporaryChatSwitcher) {
    t6 = showTemporaryChatSwitcher ? <TempChatSwitcher isTemporaryChat={isTemporaryChat} onToggleTemporaryChat={onToggleTemporaryChat} isTemporaryChatToggleDisabled={isTemporaryChatToggleDisabled} hasTemporaryMessages={hasTemporaryMessages} /> : null;
    $[11] = hasTemporaryMessages;
    $[12] = isTemporaryChat;
    $[13] = isTemporaryChatToggleDisabled;
    $[14] = onToggleTemporaryChat;
    $[15] = showTemporaryChatSwitcher;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== chatTitle || $[18] !== comparisonEnabled || $[19] !== currentChatId || $[20] !== isShareChatDisabled || $[21] !== isTemporaryChat || $[22] !== orgShares || $[23] !== organizations || $[24] !== previewPrompt || $[25] !== shareId) {
    t7 = isTemporaryChat || !currentChatId || comparisonEnabled ? null : <ShareChatDialog currentChatId={currentChatId} disabled={isShareChatDisabled} shareId={shareId} orgShares={orgShares} organizations={organizations} chatTitle={chatTitle} previewPrompt={previewPrompt} />;
    $[17] = chatTitle;
    $[18] = comparisonEnabled;
    $[19] = currentChatId;
    $[20] = isShareChatDisabled;
    $[21] = isTemporaryChat;
    $[22] = orgShares;
    $[23] = organizations;
    $[24] = previewPrompt;
    $[25] = shareId;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== mcpServers || $[28] !== onAddMcpServer || $[29] !== onRemoveMcpServer || $[30] !== onToggleMcpServer || $[31] !== onUpdateMcpServer) {
    t8 = <TooltipProvider><McpServersDialog servers={mcpServers} onAddServer={onAddMcpServer} onUpdateServer={onUpdateMcpServer} onRemoveServer={onRemoveMcpServer} onToggleServer={onToggleMcpServer} /></TooltipProvider>;
    $[27] = mcpServers;
    $[28] = onAddMcpServer;
    $[29] = onRemoveMcpServer;
    $[30] = onToggleMcpServer;
    $[31] = onUpdateMcpServer;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== comparisonEnabled || $[34] !== hideCompare || $[35] !== isTemporaryChat || $[36] !== onComparisonEnabledChange) {
    t9 = isTemporaryChat ? null : !hideCompare || comparisonEnabled ? <div className="hidden items-center gap-2 md:flex">{hideCompare ? <span className="text-muted-foreground text-xs">Comparison mode</span> : <><Label htmlFor="comparison-mode" className="text-muted-foreground text-xs">Comparison mode</Label><Switch id="comparison-mode" checked={comparisonEnabled} onCheckedChange={onComparisonEnabledChange} /></>}</div> : null;
    $[33] = comparisonEnabled;
    $[34] = hideCompare;
    $[35] = isTemporaryChat;
    $[36] = onComparisonEnabledChange;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== t6 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
    t10 = <div className="ml-3 flex items-center gap-3">{t6}{t7}{t8}{t9}</div>;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
    $[42] = t10;
  } else {
    t10 = $[42];
  }
  let t11;
  if ($[43] !== t10 || $[44] !== t5) {
    t11 = <header className="bg-background flex items-center border-b p-4">{t5}{t10}</header>;
    $[43] = t10;
    $[44] = t5;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  return t11;
};